import { css } from 'linaria';
import { tagBase } from './tags';
import classNames from 'classnames';
export const suggestedTag = "s9w7e37";
export const SuggestedTag = ({
  children,
  className,
  ...args
}) => <div className={classNames(className, tagBase, suggestedTag)} {...args}>
    {children}
  </div>;

require("../../../.linaria-cache/src/components/tags/tag-suggested.linaria.module.css");